import React from 'react'
import { Link } from 'react-scroll'


const CtaSection = (props) => {
    return(
        <div className="wpo-cta-section">
            <div className="conatiner-fluid">
                <div className="wpo-cta-item">
                    <h2>¿Listo para un evento inolvidable? Solo falta tu <span style={{ color: 'white', fontFamily: '"Jost", sans-serif'}}>''sí quiero''</span> ... asistir</h2>
                    <Link to="RSVP" spy={true} smooth={true} duration={500} className="theme-btn-s2">¡Cuenta conmigo!</Link>
                </div>
            </div>
        </div>
    )
}

export default CtaSection;